import React from "react"
import VideoComponent from "./Video"
import videoFactory from "./video.factory"

export { default as VideoQuery } from "./video.query"

export const Video = props => {
  const { data } = props
  const componentProps = { ...props, ...videoFactory.transform(data) }
  return <VideoComponent {...componentProps} />
}
